import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { TrashIcon } from 'components/icons';

export default function ImageViewer({ file, onRemoveClick, canEdit }) {
  const isVideo = file?.type?.startsWith('video/');

  return (
    <div className="w-full h-full relative group">
      {isVideo ? (
        <video
          className={'object-scale-down h-full w-full rounded' + (canEdit ? ' group-hover:opacity-30' : '')}
          src={file?.url}
          loop
          autoPlay
          muted
          playsInline
        />
      ) : (
        <img
          className={'object-scale-down h-full w-full rounded' + (canEdit ? ' group-hover:opacity-30' : '')}
          alt="IMG"
          src={file?.url}
        />
      )}

      {canEdit && (
        <div
          className="cursor-pointer absolute top-0 right-0 mr-1 opacity-0 group-hover:opacity-100 text-gray-700"
          onClick={onRemoveClick}
        >
          <Tooltip title="Slett">
            <IconButton>
              <div className="w-6 h-6">
                <TrashIcon />
              </div>
            </IconButton>
          </Tooltip>
        </div>
      )}
    </div>
  );
}